import { csColorAction, csColorBackground, csColorBorder, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'


export const cseSegmentedControlItem = {
  gap: css`var(--cse-segmented-control-item-gap, ${csSpacing.spacing04})`,
  color: css`var(--cse-segmented-control-item-color, ${csColorText.body})`,
  colorActive: css`var(--cse-segmented-control-item-color-active, ${csColorText.body})`,
  colorDisabled: css`var(--cse-segmented-control-item-color-disabled, ${csColorText.muted})`,
  colorHover: css`var(--cse-segmented-control-item-color-hover, ${csColorAction.linkSecondaryHover})`,
  backgroundColor: css`var(--cse-segmented-control-item-background-color, transparent)`,
  backgroundColorActive: css`var(--cse-segmented-control-item-background-color-active, ${csColorBackground.primary})`,
  paddingBlock: css`var(--cse-segmented-control-item-padding-y, ${csSpacing.spacing02})`,
  paddingInline: css`var(--cse-segmented-control-item-padding-x, ${csSpacing.spacing05})`,
  borderRadius: css`var(--cse-segmented-control-item-border-radius, ${csBorder.radiusMedium})`,
  activeBorderColor: css`var(--cse-segmented-control-divider-border-color, ${csColorBorder.light})`
}

export const style: CSSResult = css`
  :host {
    flex: 1;
  }

  .cse-segmented-control-item {
    position: relative;
    z-index: 1;
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${cseSegmentedControlItem.gap};
    color: ${cseSegmentedControlItem.color};
    background-color: ${cseSegmentedControlItem.backgroundColor};
    padding-block: ${cseSegmentedControlItem.paddingBlock};
    padding-inline: ${cseSegmentedControlItem.paddingInline};
    transition-property: color;
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    border-radius: ${cseSegmentedControlItem.borderRadius};
    border: none;
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: transparent;
  }

  .cse-segmented-control-item.active {
    color: ${cseSegmentedControlItem.colorActive};
  }

  .cse-segmented-control-item:not(.active, .hide-divider).behind-active {
    border-radius: 0;
    border-left-color: ${cseSegmentedControlItem.activeBorderColor};
  }

  .cse-segmented-control-item:not(.active):hover {
    color: ${cseSegmentedControlItem.colorHover}
  }

  .cse-segmented-control-item.disabled {
    color: ${cseSegmentedControlItem.colorDisabled};
    pointer-events: none;
  }
`
